/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementRef,
  AgreementRefOptional,
  AgreementRefMetaI,
  AgreementRefTrackedI,
} from "./agreement-ref";
import { AgreementRefTracked, AgreementRefMeta } from "./agreement-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonAgreementInstanceDTO,
  PersonAgreementInstanceDTOOptional,
  PersonAgreementInstanceDTOMetaI,
  PersonAgreementInstanceDTOTrackedI,
} from "./person-agreement-instance-dto";
import {
  PersonAgreementInstanceDTOTracked,
  PersonAgreementInstanceDTOMeta,
} from "./person-agreement-instance-dto";

/**
 *
 * @export
 * @interface PersonAgreementDTO
 */
export interface PersonAgreementDTOOptional {
  /**
   *
   * @type {AgreementRef}
   * @memberof PersonAgreementDTO
   */
  agreementId?: AgreementRefOptional;
  /**
   *
   * @type {PersonAgreementInstanceDTO}
   * @memberof PersonAgreementDTO
   */
  latestAgreementAction?: PersonAgreementInstanceDTOOptional;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementDTO
   */
  isAgreed?: boolean;
}

export interface PersonAgreementDTO extends PersonAgreementDTOOptional {
  /**
   *
   * @type {AgreementRef}
   * @memberof PersonAgreementDTO
   */
  agreementId?: AgreementRef;
  /**
   *
   * @type {PersonAgreementInstanceDTO}
   * @memberof PersonAgreementDTO
   */
  latestAgreementAction?: PersonAgreementInstanceDTO;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementDTO
   */
  isAgreed?: boolean;
}

export interface PersonAgreementDTOTrackedI {
  /**
   *
   * @type {AgreementRef}
   * @memberof PersonAgreementDTO
   */
  agreementId?: AgreementRefTrackedI;
  agreementIdIsSet: boolean;
  /**
   *
   * @type {PersonAgreementInstanceDTO}
   * @memberof PersonAgreementDTO
   */
  latestAgreementAction?: PersonAgreementInstanceDTOTrackedI;
  latestAgreementActionIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementDTO
   */
  isAgreed?: boolean;
  isAgreedIsSet: boolean;
}

transformDatesMap.set(
  "PersonAgreementDTO",
  function (model: PersonAgreementDTO) {
    const transformDatesagreementId = transformDatesMap.get("AgreementRef");
    if (transformDatesagreementId && model.agreementId) {
      transformDatesagreementId(model.agreementId);
    }
    const transformDateslatestAgreementAction = transformDatesMap.get(
      "PersonAgreementInstanceDTO",
    );
    if (transformDateslatestAgreementAction && model.latestAgreementAction) {
      transformDateslatestAgreementAction(model.latestAgreementAction);
    }
  },
);

export type PersonAgreementDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  agreementId: PropertyMeta<AgreementRefMetaI>;
  //isDate: false
  //isDatetime: false
  latestAgreementAction: PropertyMeta<PersonAgreementInstanceDTOMetaI>;
  //isDate: false
  //isDatetime: false
  isAgreed: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var PersonAgreementDTOMeta: PersonAgreementDTOMetaI =
  {} as PersonAgreementDTOMetaI;
PersonAgreementDTOMeta = typeMeta("PersonAgreementDTO", {
  agreementId: propertyMeta(
    "agreementId",
    false,
    false,
    false,
    AgreementRefMeta,
  ),
  latestAgreementAction: propertyMeta(
    "latestAgreementAction",
    false,
    false,
    false,
    PersonAgreementInstanceDTOMeta,
  ),
  isAgreed: propertyMeta(
    "isAgreed",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = PersonAgreementDTOMeta;

registerMeta(() => {});

export class PersonAgreementDTOTracked implements PersonAgreementDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  agreementId__I?: AgreementRefTracked = undefined;
  agreementIdIsSet: boolean = false;
  set agreementId(v: undefined | AgreementRefTracked) {
    if (v !== undefined) {
      this.agreementId__I = v;
      this.agreementIdIsSet = true;
    } else {
      this.agreementId__I = v || undefined;
      this.agreementIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementId() {
    return this.agreementId__I;
  }
  latestAgreementAction__I?: PersonAgreementInstanceDTOTracked = undefined;
  latestAgreementActionIsSet: boolean = false;
  set latestAgreementAction(v: undefined | PersonAgreementInstanceDTOTracked) {
    if (v !== undefined) {
      this.latestAgreementAction__I = v;
      this.latestAgreementActionIsSet = true;
    } else {
      this.latestAgreementAction__I = v || undefined;
      this.latestAgreementActionIsSet = false;
    }
    this.changeTracker = true;
  }
  get latestAgreementAction() {
    return this.latestAgreementAction__I;
  }
  isAgreed__I?: boolean = undefined;
  isAgreedIsSet: boolean = false;
  set isAgreed(v: undefined | boolean) {
    if (v !== undefined) {
      this.isAgreed__I = v;
      this.isAgreedIsSet = true;
    } else {
      this.isAgreed__I = v || undefined;
      this.isAgreedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isAgreed() {
    return this.isAgreed__I;
  }
  constructor(config?: PersonAgreementDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.agreementId?.setIds();

    this.latestAgreementAction?.setIds();
  }
  assignFrom(
    config: PersonAgreementDTOOptional,
    options?: AssignOptions,
  ): PersonAgreementDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.agreementId &&
      this.agreementIdApplyFilter(optionsRequired.filter)
    ) {
      this.agreementId = new AgreementRefTracked(config.agreementId, options);
      if (optionsRequired.unassign) this.agreementIdIsSet = false;
      else this.agreementIdIsSet = true;
    }
    if (
      config.latestAgreementAction &&
      this.latestAgreementActionApplyFilter(optionsRequired.filter)
    ) {
      this.latestAgreementAction = new PersonAgreementInstanceDTOTracked(
        config.latestAgreementAction,
        options,
      );
      if (optionsRequired.unassign) this.latestAgreementActionIsSet = false;
      else this.latestAgreementActionIsSet = true;
    }
    if (config.isAgreed && this.isAgreedApplyFilter(optionsRequired.filter)) {
      this.isAgreed = config.isAgreed;
      if (optionsRequired.unassign) this.isAgreedIsSet = false;
      else this.isAgreedIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonAgreementDTOTrackedI {
    const cloned = {} as PersonAgreementDTOTrackedI;
    if (
      this.agreementIdIsSetDeep() &&
      this.agreementIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementIdIsSet = true;
      cloned.agreementId = this.agreementId?.removeUnset(filter);
    } else {
      //cloned.agreementIdIsSet = false
    }
    if (
      this.latestAgreementActionIsSetDeep() &&
      this.latestAgreementActionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.latestAgreementActionIsSet = true;
      cloned.latestAgreementAction =
        this.latestAgreementAction?.removeUnset(filter);
    } else {
      //cloned.latestAgreementActionIsSet = false
    }
    if (
      this.isAgreedIsSetDeep() &&
      this.isAgreedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isAgreedIsSet = true;
      cloned.isAgreed = this.isAgreed;
    } else {
      //cloned.isAgreedIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonAgreementDTOTrackedI {
    if (!this.agreementIdApplyFilter(filter)) this.agreementIdIsSet = false;
    this.agreementId?.unassignAll(filter);

    if (!this.latestAgreementActionApplyFilter(filter))
      this.latestAgreementActionIsSet = false;
    this.latestAgreementAction?.unassignAll(filter);

    if (!this.isAgreedApplyFilter(filter)) this.isAgreedIsSet = false;

    return this;
  }
  agreementIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementDTOMeta.agreementId,
      PersonAgreementDTOMeta,
      this.agreementId,
      this,
    );
  }
  agreementIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementIdIsSet && this.agreementIdApplyFilter(filter))
      return true;
    return this.agreementId?.anySet(filter) == true;

    return false;
  }
  latestAgreementActionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementDTOMeta.latestAgreementAction,
      PersonAgreementDTOMeta,
      this.latestAgreementAction,
      this,
    );
  }
  latestAgreementActionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.latestAgreementActionIsSet &&
      this.latestAgreementActionApplyFilter(filter)
    )
      return true;
    return this.latestAgreementAction?.anySet(filter) == true;

    return false;
  }
  isAgreedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementDTOMeta.isAgreed,
      PersonAgreementDTOMeta,
      this.isAgreed,
      this,
    );
  }
  isAgreedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isAgreedIsSet && this.isAgreedApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.agreementIdIsSetDeep(filter)) return true;
    if (this.latestAgreementActionIsSetDeep(filter)) return true;
    if (this.isAgreedIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
